import { useState, useRef, useEffect, useCallback } from "react";
import { API } from "./api";

// OpenAI TTS (voix Shimmer, vitesse 0.9) via le backend, joué en HTML5 Audio.
export function useTTS() {
  const [status, setStatus] = useState("idle"); // idle | loading | playing | paused | error
  const audioRef = useRef(null);
  const urlRef = useRef(null);

  const cleanup = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }
    if (urlRef.current) {
      URL.revokeObjectURL(urlRef.current);
      urlRef.current = null;
    }
  }, []);

  useEffect(() => () => cleanup(), [cleanup]);

  const toggle = useCallback(
    async (text) => {
      if (status === "playing" && audioRef.current) {
        audioRef.current.pause();
        setStatus("paused");
        return;
      }
      if (status === "paused" && audioRef.current) {
        await audioRef.current.play();
        setStatus("playing");
        return;
      }
      try {
        setStatus("loading");
        const res = await fetch(`${API}/tts`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ text, voice: "shimmer", speed: 0.9 }),
        });
        if (!res.ok) throw new Error("tts failed");
        const blob = await res.blob();
        cleanup();
        const url = URL.createObjectURL(blob);
        urlRef.current = url;
        const audio = new Audio(url);
        audioRef.current = audio;
        audio.onended = () => setStatus("idle");
        audio.onerror = () => setStatus("error");
        await audio.play();
        setStatus("playing");
      } catch {
        setStatus("error");
      }
    },
    [status, cleanup]
  );

  const stop = useCallback(() => {
    cleanup();
    setStatus("idle");
  }, [cleanup]);

  return { status, toggle, stop };
}
